import { createPaymentDetailsContainer } from './container'
import { PaymentDetails as PaymentDetailsUI } from './ui/payment-details'

export const PaymentDetails = createPaymentDetailsContainer(PaymentDetailsUI)
